import { Funnel } from 'features/co-pilot/co-pilot.types';
import { OptionType } from 'features/ui/base-components/pai-auto-complete';
import PaiMenuItem from 'features/ui/base-components/pai-menu-item';
import PaiSelect from 'features/ui/base-components/pai-select';
import { BasicActionDialog } from 'features/ui/base-dialogs';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  loading: boolean;
  funnels: Funnel[];
  selectedFunnel: string | null;

  handleSelectedFunnelChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  handleAddContacts(): void;
}

const AddContactsToCampaignDialog: React.FC<Props> = ({
  open,
  loading,
  funnels,
  selectedFunnel,
  handleSelectedFunnelChange,
  handleClose,
  handleAddContacts,
}) => {
  const { t } = useTranslation();

  const options: OptionType[] = useMemo(() => funnels.map((funnel) => ({ label: funnel.name, value: funnel._id })), [funnels]);

  return (
    <BasicActionDialog
      open={open}
      maxWidth={'xs'}
      dialogTitle={t('addContactsToCampaign')}
      proceedButtonText={t('add')}
      handleProceed={handleAddContacts}
      proceedButtonDisabled={!selectedFunnel}
      cancelButtonText={t('cancel')}
      handleClose={handleClose}
      loading={loading}
    >
      <PaiSelect value={selectedFunnel || ''} label={t('campaign')} onChange={handleSelectedFunnelChange}>
        {options.map((option) => (
          <PaiMenuItem key={option.value} value={option.value}>
            {option.label}
          </PaiMenuItem>
        ))}
      </PaiSelect>
    </BasicActionDialog>
  );
};

export default AddContactsToCampaignDialog;
